'use client'

import dynamic from 'next/dynamic'
import SmoothScrollProvider from './components/smooth-scroll-provider'
import Header from './components/header'
import Hero from './components/hero'
import About from './components/about'
import Work from './components/work'
import Skills from './components/skills'
import Experience from './components/experience'
import Contact from './components/contact'
import Footer from './components/footer'
import ScrollToTop from './components/scroll-to-top'

const CustomCursor = dynamic(() => import('./components/custom-cursor'), {
	ssr: false
})

export default function Home() {
	return (
		<SmoothScrollProvider>
			<div className="relative">
				<CustomCursor />
				<Header />
				<main>
					<Hero />
					<About />
					<Work />
					<Skills />
					<Experience />
					<Contact />
				</main>
				<Footer />
				<ScrollToTop />
			</div>
		</SmoothScrollProvider>
	)
}
